import { Injectable } from "@angular/core";
import {
  PRIMITIVE,
  ClientMessageBrokerFactory,
  ClientMessageBroker,
  FnArg,
  UiArguments,
  FnTransferableArg,
} from "shared/provider-webworker";
import { CubiqWorker } from "../../worker/CubiqWorker";
import { TraderGroupLookupService } from "../../lookup/model/impl/TraderGroupLookupService";

import { Subject } from "rxjs";

import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { FindActionPromiseService } from "./FindActionPromiseService";
import { FIND_ACTION } from "../IFindActionService";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class FindActionReplicaService implements FindActionPromiseService {
  protected broker: ClientMessageBroker;

  constructor(protected factory: ClientMessageBrokerFactory) {
    this.broker = this.factory.createMessageBroker(FIND_ACTION, true, true);
  }

  public findDeals(data: any): Promise<any> {
    let request = new UiArguments("findDeals");

    request.args = [new FnArg(data, PRIMITIVE)];

    return this.broker.runOnService(request, PRIMITIVE);
  }

  public findOrders(data: any): Promise<any> {
    let request = new UiArguments("findOrders");

    request.args = [new FnArg(data, PRIMITIVE)];

    return this.broker.runOnService(request, PRIMITIVE);
  }
}
